import { Header } from "@dn/components/header/header";
import { lazyLoadStylesheets } from "@dn/scripts/plugins/lazyLoadStylesheets";
import { lazyLoadImages } from "@dn/scripts/plugins/lazyLoadImages";
import { OfferCard } from "@dn/components/li/offer-card/offer-card";
import { Modal } from "@dn/components/modal/modal";
import { Tooltip } from "@dn/components/tooltip/tooltip";
import { EnterprisePage } from "../components/enterprise-page/enterprise-page";
import { ContentBlock } from "../components/content-block/content-block";

const lazyImages = document.getElementsByClassName("lazy-image");
lazyLoadImages(lazyImages);

lazyLoadStylesheets("lazy-stylesheet");

const headerEl = document.querySelector(".header");
if (headerEl) Header(headerEl);

const offerCards = document.querySelectorAll(".offer-card");
if (offerCards.length) OfferCard(offerCards);

const modals = document.querySelectorAll(".modal");
if (modals.length) {
  modals.forEach((element) => {
    const triggers = document.querySelectorAll(".open-modal");
    Modal(element, { triggers });
  });
}

const tooltips = document.querySelectorAll(".tooltip");
if (tooltips.length) {
  tooltips.forEach((tooltip) => {
    Tooltip(tooltip);
  });
}

const contentBlocks = document.querySelectorAll(".content-block__container");
if (contentBlocks.length) {
  contentBlocks.forEach((contentBlock) => {
    ContentBlock(contentBlock);
  });
}

const enterpriseEl = document.querySelector(".enterprise-page");
if (enterpriseEl) EnterprisePage(enterpriseEl);

